module.exports = __webpack_public_path__ + "static/media/cable.a9739f10.svg";